import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { IsOpen } from '../../../components/Icon';
import { ChangeLocationModal } from './ChangeLocationModal';
import { setVehicleLocation, setVehicleProperty } from '../actions';
import { CompanyLabel } from '../../Companies/components/CompanyLabel';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import cn from 'classnames';
import styles from './VehicleLocationCard.module.css';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../Companies/translate-countries';
import { getPropByName } from '../../../utils/props';
import { VehiclePropertyLoadable } from './VehiclePropertyLoadable';
import { HILT_PARKINGSPOT } from '../installations/13/constants';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const Address = styled.div`
  border: 2px solid var(--color-new-secondary);
  border-radius: 6px;
  padding: 12px;
  width: 100%;
  margin: 6px 0;
  font-size: 12px;

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

class VehicleLocationCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      address: null,
      company: null,
      localShowLocationChange: false, // Local state for the modal
    });
  }

  componentDidMount() {
    if (env.clientId === AppClientId.HILTERMANN) {
      this.setState({
        [HILT_PARKINGSPOT]: getPropByName(this.props.vehicle, HILT_PARKINGSPOT) ?? '',
      });
    }
  }

  toggleLocalModal = () => {
    this.setState(prevState => ({
      localShowLocationChange: !prevState.localShowLocationChange,
    }));
  };

  onSetLocation = (company, address) => {
    this.props.changeLocation(this.props.vehicle?.id, company?.id, address?.id);
    this.props.setShowLocationChange?.(false); // Parent control (if provided)
    this.setState({ localShowLocationChange: false }); // Local control
  };

  renderAddress = () => {
    let company = this.props.vehicle?.locationCompany;
    let address = this.props.vehicle?.locationAddress;

    if (env.clientId === AppClientId.HOOIKAMMER) {
      if (this.props.vehicle?.HOOI_uitslag_done) {
        address = {
          id: 1,
          name: 'Niet aanwezig bij Hooikammer Fleetservice',
          addressLine1: '',
          postcode: '',
          city: '',
          country: { name: '' },
        };
      }
    } else {
      if (!address) {
        return null;
      }
    }

    return (
      <Address key={address?.id}>
        {company && (
          <span className="name" style={{ textTransform: 'uppercase', fontWeight: 600 }}>
            <CompanyLabel company={company} />
          </span>
        )}
        <HBox vCenter left>
          {this.lbl(address?.type?.name || address?.name)}
        </HBox>

        <VBox left>
          <div>{address?.addressLine1}</div>
          <div>
            {address?.postcode} {address?.city}
          </div>
          <div>{translateCountry(address?.country?.name, this.locale)}</div>
        </VBox>
      </Address>
    );
  };

  renderLocationButtons = () => {
    const { vehicle } = this.props;

    if (this.props.weblogin) return null;

    return (
      <>
        {vehicle?.location_address_id === '5' ? (
          <Button className={styles.buttonLinktree} onClick={() => this.props.setValueLocationAddress('5')}>
            {env.clientId === AppClientId.HOOIKAMMER
              ? this.lbl('vehicle.linktree.steenwijk')
              : env.clientId === AppClientId.HILTERMANN
              ? this.lbl('vehicle.linktree.grote_loods')
              : this.lbl('vehicle.linktree.home')}
          </Button>
        ) : (
          <Button className={styles.buttonChange} onClick={() => this.props.setValueLocationAddress('5')}>
            {env.clientId === AppClientId.HOOIKAMMER
              ? this.lbl('vehicle.linktree.steenwijk')
              : env.clientId === AppClientId.HILTERMANN
              ? this.lbl('vehicle.linktree.grote_loods')
              : this.lbl('vehicle.linktree.home')}
          </Button>
        )}
        
        {env.clientId === AppClientId.HOOIKAMMER && (
          <div>
            {vehicle?.location_address_id === '390' ? (
              <Button className={styles.buttonLinktree} onClick={() => this.props.setValueLocationAddress('390')}>
                {this.lbl('vehicle.linktree.opslag')}
              </Button>
            ) : (
              <Button className={styles.buttonChange} onClick={() => this.props.setValueLocationAddress('390')}>
                {this.lbl('vehicle.linktree.opslag')}
              </Button>
            )}
            {vehicle?.location_address_id === '339' ? (
              <Button className={styles.buttonChange} primary onClick={() => this.props.setValueLocationAddress('339')}>
                {this.lbl('vehicle.linktree.staphorst')}
              </Button>
            ) : (
              <Button className={styles.buttonChange} onClick={() => this.props.setValueLocationAddress('339')}>
                {this.lbl('vehicle.linktree.staphorst')}
              </Button>
            )}
            {vehicle?.location_address_id === '570' ? (
              <Button primary onClick={() => this.props.setValueLocationAddress('570')}>
                {this.lbl('vehicle.linktree.abcamsterdam')}
              </Button>
            ) : (
              <Button onClick={() => this.props.setValueLocationAddress('570')}>
                {this.lbl('vehicle.linktree.abcamsterdam')}
              </Button>
            )}
            {vehicle?.location_address_id === '571' ? (
              <Button primary onClick={() => this.props.setValueLocationAddress('571')}>
                {this.lbl('vehicle.linktree.reservelocatie')}
              </Button>
            ) : (
              <Button onClick={() => this.props.setValueLocationAddress('571')}>
                {this.lbl('vehicle.linktree.reservelocatie')}
              </Button>
            )}
          </div>
        )}

        {env.clientId === AppClientId.HILTERMANN && (
          <div>
            {vehicle?.location_address_id === '4' ? (
              <Button className={styles.buttonLinktree} onClick={() => this.props.setValueLocationAddress('4')}>
                {this.lbl('vehicle.linktree.kleine_loods')}
              </Button>
            ) : (
              <Button className={styles.buttonChange} onClick={() => this.props.setValueLocationAddress('4')}>
                {this.lbl('vehicle.linktree.kleine_loods')}
              </Button>
            )}
            {vehicle?.location_address_id === '6' ? (
              <Button className={styles.buttonChange} primary onClick={() => this.props.setValueLocationAddress('6')}>
                {this.lbl('vehicle.linktree.Parkeergarage')}
              </Button>
            ) : (
              <Button className={styles.buttonChange} onClick={() => this.props.setValueLocationAddress('6')}>
                {this.lbl('vehicle.linktree.Parkeergarage')}
              </Button>
            )}
            <>
              <VehiclePropertyLoadable name={HILT_PARKINGSPOT}>
                <label className={cn('form-label', styles.label)}>{this.lbl(`vehicle.property.${HILT_PARKINGSPOT}`)}</label>
                <input
                  className="form-control"
                  value={this.state[HILT_PARKINGSPOT]}
                  onChange={e => this.setState({ [HILT_PARKINGSPOT]: e.target.value })}
                  onBlur={() => {
                    this.state[HILT_PARKINGSPOT] && this.props.setProperty(HILT_PARKINGSPOT, this.state[HILT_PARKINGSPOT]);
                  }}
                />
              </VehiclePropertyLoadable>
            </>
          </div>
        )}
      </>
    );
  };

  render() {
    const { vehicle, showLocationChange, setShowLocationChange } = this.props;
    const isModalVisible = this.state.localShowLocationChange || showLocationChange;
     return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          <HBox>
            <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.info.location.title')}</h2>
          </HBox>

          {this.renderAddress()}

          {/* <HBox right>
            <Button
              className={styles.buttonChange}
              small
              onClick={setShowLocationChange ? () => setShowLocationChange(true) : this.toggleLocalModal}
            >
              {this.lbl('vehicle.location.change')}
            </Button>
          </HBox> */}

          {isModalVisible && (
            <ChangeLocationModal
              vehicleId={vehicle?.id}
              vehicle_details={this.props.vehicle_details}
              company={vehicle?.locationCompany}
              address={vehicle?.locationAddress}
              onClose={setShowLocationChange ? () => setShowLocationChange(false) : this.toggleLocalModal}
              onConfirm={this.onSetLocation}
            />
          )}

          {!isModalVisible && (
            <HBox right>
              <Button
                className={styles.buttonChange}
                small
                onClick={setShowLocationChange ? () => setShowLocationChange(true) : this.toggleLocalModal}
              >
                {this.lbl('vehicle.location.change')}
              </Button>
            </HBox>
          )}

          {this.renderLocationButtons()}
        </Container>
      </Card>
    );
  }
}

VehicleLocationCardComp.propTypes = {
  vehicle: PropTypes.object.isRequired,
  showLocationChange: PropTypes.bool, // Optional for parent control
  setShowLocationChange: PropTypes.func, // Optional for parent control
  changeLocation: PropTypes.func.isRequired,
  setValueLocationAddress: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    changeLocation: (vehicleId, companyId, addressId) => {
      dispatch(setVehicleLocation(vehicleId, companyId, addressId));
    },
    setValueLocationAddress(addressId) {
      if (env.clientId === AppClientId.HARRY_NIJBOER) {
        dispatch(setVehicleLocation(ownProps.vehicle.id, '28', '29'));
      } else {
        dispatch(setVehicleLocation(ownProps.vehicle.id, '4', addressId));
      }
    },
    setProperty(name, value, callback) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, name, value, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleLocationCard = compose(withConnect, withRouter)(VehicleLocationCardComp);
